export const primaryColor = '#99b5c1'; // Keep in sync with content.css .title color
export const secondaryColor = '#bfbfd5';
export const textColor = '#d5dce1'; // Keep in sync with content.css .text-body color
export const linkColor = '#8fb5d3';
